"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "m16.196 11.766 4.7 4.732c.321.32.484.716.489 1.186.004.469-.158.869-.489 1.2a1.62 1.62 0 0 1-1.193.481 1.62 1.62 0 0 1-1.192-.482l-5.907-5.906a1.66 1.66 0 0 1-.374-.564 1.735 1.735 0 0 1 0-1.294 1.66 1.66 0 0 1 .374-.564l5.907-5.907a1.636 1.636 0 0 1 1.185-.488c.47-.005.87.158 1.2.488.321.321.482.719.482 1.193 0 .474-.16.872-.482 1.193l-4.7 4.732Zm-8.737 0 4.718 4.732c.321.32.484.716.489 1.186.004.469-.159.869-.49 1.2a1.62 1.62 0 0 1-1.192.481 1.62 1.62 0 0 1-1.193-.482l-5.906-5.906a1.66 1.66 0 0 1-.374-.564 1.735 1.735 0 0 1 0-1.294 1.66 1.66 0 0 1 .374-.564L9.79 4.648a1.636 1.636 0 0 1 1.186-.488c.47-.005.87.158 1.2.488.321.321.482.719.482 1.193 0 .474-.161.872-.482 1.193l-4.718 4.732Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};